import React, { useState } from 'react';
import { Select } from 'antd';
import PublishersCTRTable from './PublisherCTRTable';
import PublisherRingChart from './PublisherRingChart';
import SearchBar from '../../../../../../shared/designSystem/components/SearchBar';
import EntityBreakdownCard from '../../../../../../shared/designSystem/components/EntityBreakdownCard';
import { prepareCTR } from '../../../../../../../core/utils/campaigns';
import { MenuItemText } from '../../../../../../shared/globalStyling/styledText';
import { getRingColor } from '../../../../../../shared/designSystem/components/BreakdownRingChart';

const { Option } = Select;

const KEY_COLORS = {
  spent: '#1665d8',
  remaining: '#34aa44',
  budget: '#030303',
  total: '#bec0c3',
  value: '#99999',
};

const SHOW_BY_OPTIONS = [
  { value: 'impressions', text: 'Impressions' },
  { value: 'CTR', text: 'CTR Percentage' },
  { value: 'clicks', text: 'Clicks' },
];

// Special synthetic value used in v1 to bucket legacy DSP publishers — must
// always sort to the bottom of the list so the user sees current publishers
// first. Preserved verbatim from v1 so no backend contract changes.
const ARCHIVED_LABEL = 'z_archive Deprecated DSP Publishers';

// =============================================================================
// PublisherDetails — unified Publishers + Breakdown card, mirrors Creatives.
// =============================================================================

const PublisherDetails = (props) => {
  const { selectedPublisherDimension, setPublisherDimension, publisherData } = props;
  const [searchValue, setSearchValue] = useState('');

  const parsedData = prepareCTR(publisherData);
  const colorValuePairs = parsedData.map((el, index) => {
    if (el.xAxis) {
      return { ...el, value: el.xAxis, color: getRingColor(index) };
    } else if (el.value) {
      return { ...el, color: getRingColor(index) };
    }
    return { ...el, value: ARCHIVED_LABEL, color: getRingColor(index) };
  });

  const filteredData = colorValuePairs
    .filter((item) =>
      String(item.value ?? '')
        .toLowerCase()
        .includes(searchValue.toLowerCase())
    )
    .sort((a, b) => {
      // Move archived publishers to the end; preserve relative order otherwise.
      const aArchived = a.value === ARCHIVED_LABEL;
      const bArchived = b.value === ARCHIVED_LABEL;
      if (aArchived && !bArchived) return 1;
      if (!aArchived && bArchived) return -1;
      return 0;
    });

  return (
    <EntityBreakdownCard
      title="Publishers"
      search={
        <SearchBar
          placeholder="Search publishers..."
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          className="campaign-overview__creatives-search"
        />
      }
      table={<PublishersCTRTable publisherData={filteredData} />}
      breakdownControl={
        <Select
          defaultValue={SHOW_BY_OPTIONS[0].value}
          onChange={(value) => setPublisherDimension(value)}
          getPopupContainer={(trigger) => trigger.parentNode}
          popupClassName="mjl-ds"
          className="campaign-overview__creatives-showby"
          size="small"
        >
          {SHOW_BY_OPTIONS.map((option) => (
            <Option key={option.value} value={option.value}>
              <MenuItemText text={option.text} />
            </Option>
          ))}
        </Select>
      }
      breakdownChart={
        <PublisherRingChart
          data={filteredData}
          keyColors={KEY_COLORS}
          height={480}
          selectedPublisherDimension={selectedPublisherDimension}
        />
      }
    />
  );
};

export default PublisherDetails;
